import { useState } from "react";
import Form from "react-bootstrap/Form";

export default function SortDropdown(props) {

  const [sortByCollapsed, setSortByCollapsed] = useState(false)

  return (
    // dropdown menu with list of sorting options
    
    <Form.Group >
      <Form.Label style={{ display: "flex", justifyContent: "space-between"}}>
        <b>{props?.heading ? props.heading : "Sort By"}</b>
        {sortByCollapsed ? <i onClick={() => setSortByCollapsed(false)} className="bi bi-plus pointer"></i> : <i onClick={() => setSortByCollapsed(true)} className="bi bi-dash pointer"></i>}
      
      </Form.Label>
      <div className={sortByCollapsed ? "hide-element" : ""}
>
        <Form.Select value={props.selectedSort} 
        onChange = {(event) => {
          props.handleChangeSortKey(event.target.value)
        }}
        >
      {props?.sortOptions.map((option, idx) => {
        return (
        <option key={idx} value={option.value}>{option.label}</option>
        )
      })}
      </Form.Select>
      </div>

    </Form.Group>
  );
}
